import React from 'react'
import { Alert } from '@material-ui/lab'
import { Grid, makeStyles } from '@material-ui/core'
import { hideEmail } from '../../../Utils/Functions'
import { styles } from './styles'
import ResendEmailTimer from './ResendEmailTimer'
import AlertParentStyler from './AlertParentStyler'

const useStyles = makeStyles(() => styles)

export const VerifyEmail = ({ email, sendVerificationEmail }) => {
  const classes = useStyles()
  return (
    <AlertParentStyler style={{ background: 'rgb(249, 249, 255)' }}>
      <Alert severity="error" className={classes.alert}>
        <Grid container xl={12} className={classes.container}>
          <Grid item xs={12} sm={'auto'} className={classes.text}>
            Please check your mailbox {hideEmail(email)} (including spam) and
            validate your email to save your campaign.{' '}
          </Grid>
          <Grid item xs={12} sm={'auto'} className={classes.action}>
            <ResendEmailTimer
              sendVerificationEmail={sendVerificationEmail}
              email={email}
            />
          </Grid>
        </Grid>
      </Alert>
    </AlertParentStyler>
  )
}
